import {GetterTree} from 'vuex'
import {IAuthentificationStateModel, IRootStateModel} from './../../../interfaces'
import {Profile} from '@/services/types'

export type AuthentificationGetters = {
    isAuthentificationDataLoading(state: IAuthentificationStateModel): boolean;
    isAuthentificationError(state: IAuthentificationStateModel): boolean;
    getAuthentificationProfile(state: IAuthentificationStateModel): Profile | null;
    getAuthentificationHelperText(state: IAuthentificationStateModel): string;
    isAuthentificationAuthenticated(state: IAuthentificationStateModel): boolean;
}

export const getters: GetterTree<IAuthentificationStateModel, IRootStateModel> & AuthentificationGetters = {
    getAuthentificationHelperText: (state: IAuthentificationStateModel) => {
        return state.helperText
    },
    getAuthentificationProfile: (state: IAuthentificationStateModel) => {
        return state.profile
    },
    isAuthentificationAuthenticated: (state: IAuthentificationStateModel) => {
        return state.authenticated
    },
    isAuthentificationDataLoading: (state: IAuthentificationStateModel) => {
        return state.dataIsLoading
    },
    isAuthentificationError: (state: IAuthentificationStateModel) => {
        return state.error
    }
}